import React from 'react'
import Component from '@reactions/component'

const State = ({ initial, render }) => (
  <Component
    initialState={initial}
    render={({ state, setState }) => render({ state, setState })}
  />
)

export default State



// WEBPACK FOOTER //
// ./src/components/State.js